(() => {
/*
  EDITABLE BUILDER CONTENT
  To replace a product, edit only this block:
  - label/prompt: section text
  - sizes: visible size buttons for that category
  - products[].name: product card title
  - products[].sku: real product SKU
  - products[].price: retail price used in dynamic retail value; keep null until confirmed
  - products[].url: product detail page link
  - products[].colours: visible colour swatches for that product
  - products[].colours[].image: optional colour-specific image from theme editor
  - products[].note/fabric: small lines below the title
  - products[].image: default image from theme editor
  - products[].imagePosition: optional object-position for fine tuning
*/
const Founder100Assets = window.FOUNDER100_ASSETS || {};
let pageRoot = null;
let SECTION_COPY = {
  mobilePrice: "Founder price £39",
  mobileReady: "Set ready",
  pending: "Pending"
};

function refreshSectionContext() {
  pageRoot = document.getElementById("founder100-page");
  SECTION_COPY = {
    mobilePrice: pageRoot?.dataset.mobilePriceText || "Founder price £39",
    mobileReady: pageRoot?.dataset.mobileReadyText || "Set ready",
    pending: pageRoot?.dataset.pendingText || "Pending"
  };
}

function normalizeOption(value) {
  return String(value || "").trim().toLowerCase();
}

function configuredSoldOutOptions() {
  return String(pageRoot?.dataset.soldOutOptions || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line && !line.startsWith("#"))
    .map((line) => line.split(/\s*(?:\||,)\s*/))
    .filter((parts) => parts.length >= 3)
    .map(([sku, color, size]) => ({ sku, color, size }));
}

const BUILDER_CONTENT = {
  stepOrder: ["short", "legging", "bra"],
  sizeOrder: ["S", "M", "L", "XL"],
  sizeChart: [
    { size: "S", bust: [84, 90], waist: [66, 72], hip: [90, 96] },
    { size: "M", bust: [90, 96], waist: [72, 78], hip: [96, 102] },
    { size: "L", bust: [96, 104], waist: [78, 86], hip: [102, 110] },
    { size: "XL", bust: [104, 112], waist: [86, 94], hip: [110, 118] }
  ],
  steps: {
    short: {
      label: "Short",
      step: "01",
      prompt: "Choose your short.",
      sizes: ["S", "M", "L", "XL"],
      startsOpen: true,
      products: [
        {
          sku: "FW-YG-SHT001",
          name: "Flow Ease Short 4\"",
          series: "Flow",
          price: 38,
          note: "Nylon 66 and LYCRA fibre short.",
          fabric: "81% Nylon 66 / 19% LYCRA fibre",
          colourCount: 3,
          sizeRange: "S-XL",
          url: "https://formwynn.com/products/flow-ease-short-4",
          image: Founder100Assets["FW-YG-SHT001"],
          imagePosition: "50% 50%",
          colours: [
            {
              name: "Black",
              value: "#242321",
              image: Founder100Assets["FW-YG-SHT001-BLACK"]
            },
            {
              name: "Warm Sand",
              value: "#c1ad94",
              image: Founder100Assets["FW-YG-SHT001-WARM-SAND"]
            },
            {
              name: "Coastal Blue",
              value: "#6d8194",
              image: Founder100Assets["FW-YG-SHT001-COASTAL-BLUE"]
            }
          ]
        },
        {
          sku: "FW-HB-SHT001",
          name: "Hybrid Race Short 5\"",
          series: "Hybrid",
          price: 42,
          note: "The work is done. The training is behind you.",
          fabric: "75% Polyamide / 25% Elastane",
          colourCount: 3,
          sizeRange: "S-XL",
          url: "https://formwynn.com/products/hybrid-race-short-5",
          image: Founder100Assets["FW-HB-SHT001"],
          imagePosition: "50% 50%",
          colours: [
            {
              name: "Obsidian Black",
              value: "#242321",
              image: Founder100Assets["FW-HB-SHT001-OBSIDIAN-BLACK"]
            },
            {
              name: "Angola Red",
              value: "#7d2a2e",
              image: Founder100Assets["FW-HB-SHT001-ANGOLA-RED"]
            },
            {
              name: "Deep Navy",
              value: "#202a38",
              image: Founder100Assets["FW-HB-SHT001-DEEP-NAVY"]
            }
          ]
        },
        {
          sku: "FW-HB-SHT002",
          name: "Hybrid Interval Short 9\"",
          series: "Hybrid",
          price: 46,
          note: "Race day gets remembered. Most training doesn't.",
          fabric: "75% Polyamide / 25% Elastane",
          colourCount: 3,
          sizeRange: "S-XL",
          url: "https://formwynn.com/products/hybrid-interval-short-9",
          image: Founder100Assets["FW-HB-SHT002"],
          imagePosition: "50% 50%",
          colours: [
            {
              name: "Obsidian Black",
              value: "#242321",
              image: Founder100Assets["FW-HB-SHT002-OBSIDIAN-BLACK"]
            },
            {
              name: "Angola Red",
              value: "#7d2a2e",
              image: Founder100Assets["FW-HB-SHT002-ANGOLA-RED"]
            },
            {
              name: "Deep Navy",
              value: "#202a38",
              image: Founder100Assets["FW-HB-SHT002-DEEP-NAVY"]
            }
          ]
        }
      ]
    },
    legging: {
      label: "Legging",
      step: "02",
      prompt: "Choose your legging.",
      sizes: ["S", "M", "L", "XL"],
      startsOpen: false,
      products: [
        {
          sku: "FW-YG-LGG004",
          name: "Flow Wave Legging 7/8",
          series: "Flow",
          price: 56,
          note: "Grounded in form. Worn without boundaries.",
          fabric: "75% Nylon / 25% LYCRA",
          colourCount: 2,
          sizeRange: "S-XL",
          url: "https://formwynn.com/products/flow-wave-legging-78",
          image: Founder100Assets["FW-YG-LGG004"],
          imagePosition: "50% 50%",
          colours: [
            {
              name: "Obsidian Black",
              value: "#242321",
              image: Founder100Assets["FW-YG-LGG004-OBSIDIAN-BLACK"]
            },
            {
              name: "Angola Red",
              value: "#7d2a2e",
              image: Founder100Assets["FW-YG-LGG004-ANGOLA-RED"]
            }
          ]
        },
        {
          sku: "FW-YG-LGG003",
          name: "Flow Stirrup Legging",
          series: "Flow",
          price: 64,
          note: "A familiar shape. Reconsidered.",
          fabric: "75% Nylon / 25% LYCRA",
          colourCount: 2,
          sizeRange: "S-XL",
          url: "https://formwynn.com/products/flow-stirrup-legging",
          image: Founder100Assets["FW-YG-LGG003"],
          imagePosition: "50% 50%",
          colours: [
            {
              name: "Obsidian Black",
              value: "#242321",
              image: Founder100Assets["FW-YG-LGG003-OBSIDIAN-BLACK"]
            },
            {
              name: "Angola Red",
              value: "#7d2a2e",
              image: Founder100Assets["FW-YG-LGG003-ANGOLA-RED"]
            }
          ]
        },
        {
          sku: "FW-YG-LGG001",
          name: "Flow Core Legging",
          series: "Flow",
          price: 48,
          note: "Softly worn. Effortlessly lived in.",
          fabric: "80% Nylon / 20% Elastane",
          colourCount: 6,
          sizeRange: "S-XL",
          url: "https://formwynn.com/products/flow-core-legging",
          image: Founder100Assets["FW-YG-LGG001"],
          imagePosition: "50% 50%",
          colours: [
            {
              name: "Obsidian Black",
              value: "#242321",
              image: Founder100Assets["FW-YG-LGG001-OBSIDIAN-BLACK"]
            },
            {
              name: "Mist Blue",
              value: "#9aa9b4",
              image: Founder100Assets["FW-YG-LGG001-MIST-BLUE"]
            },
            {
              name: "Mink Grey",
              value: "#a7a19a",
              image: Founder100Assets["FW-YG-LGG001-MINK-GREY"]
            },
            {
              name: "Sage Green",
              value: "#7c8a76",
              image: Founder100Assets["FW-YG-LGG001-SAGE-GREEN"]
            },
            {
              name: "Dusty Rose",
              value: "#b98b86",
              image: Founder100Assets["FW-YG-LGG001-DUSTY-ROSE"]
            },
            {
              name: "Aubergine",
              value: "#4b3545",
              image: Founder100Assets["FW-YG-LGG001-AUBERGINE"]
            }
          ]
        },
        {
          sku: "FW-YG-FLA001",
          name: "Flow Line Flare",
          series: "Flow",
          price: 58,
          note: "A longer line changes everything.",
          fabric: "81% Nylon / 19% Xtra Soft Elastane",
          colourCount: 3,
          sizeRange: "S-XL",
          url: "https://formwynn.com/products/flow-line-flare",
          image: Founder100Assets["FW-YG-FLA001"],
          imagePosition: "50% 50%",
          colours: [
            {
              name: "Black",
              value: "#242321",
              image: Founder100Assets["FW-YG-FLA001-BLACK"]
            },
            {
              name: "Deep Navy",
              value: "#202a38",
              image: Founder100Assets["FW-YG-FLA001-DEEP-NAVY"]
            },
            {
              name: "Earth",
              value: "#6f6254",
              image: Founder100Assets["FW-YG-FLA001-EARTH"]
            }
          ]
        },
        {
          sku: "FW-HB-LGG001",
          name: "Hybrid Pace Tight 7/8",
          series: "Hybrid",
          price: 62,
          note: "Some tights are built for training. Others are built for everything after it.",
          fabric: "75% Polyamide / 25% Elastane",
          colourCount: 3,
          sizeRange: "S-XL",
          url: "https://formwynn.com/products/hybrid-pace-tight-78",
          image: Founder100Assets["FW-HB-LGG001"],
          imagePosition: "50% 50%",
          colours: [
            {
              name: "Obsidian Black",
              value: "#242321",
              image: Founder100Assets["FW-HB-LGG001-OBSIDIAN-BLACK"]
            },
            {
              name: "Angola Red",
              value: "#7d2a2e",
              image: Founder100Assets["FW-HB-LGG001-ANGOLA-RED"]
            },
            {
              name: "Deep Navy",
              value: "#202a38",
              image: Founder100Assets["FW-HB-LGG001-DEEP-NAVY"]
            }
          ]
        }
      ]
    },
    bra: {
      label: "Bra",
      step: "03",
      prompt: "Choose your bra.",
      sizes: ["S", "M", "L"],
      startsOpen: false,
      products: [
        {
          sku: "FW-YG-BRA001",
          name: "Flow Wynn Bra",
          series: "Flow",
          price: 36,
          note: "Flow upper in a close, clean silhouette.",
          fabric: "78% Polyamide / 22% Elastane",
          colourCount: 3,
          sizeRange: "S-L",
          url: "https://formwynn.com/products/flow-wynn-bra",
          image: Founder100Assets["FW-YG-BRA001"],
          imagePosition: "50% 50%",
          colours: [
            {
              name: "Obsidian Black",
              value: "#242321",
              image: Founder100Assets["FW-YG-BRA001-OBSIDIAN-BLACK"]
            },
            {
              name: "Soft Sage",
              value: "#9daa93",
              image: Founder100Assets["FW-YG-BRA001-SOFT-SAGE"]
            },
            {
              name: "Chocolate Brown",
              value: "#4a352d",
              image: Founder100Assets["FW-YG-BRA001-CHOCOLATE-BROWN"]
            }
          ]
        },
        {
          sku: "FW-YG-BRA002",
          name: "Flow Ease Bra",
          series: "Flow",
          price: 40,
          note: "Nylon 66 and LYCRA fibre bra.",
          fabric: "81% Nylon 66 / 19% LYCRA fibre",
          colourCount: 5,
          sizeRange: "S-L",
          url: "https://formwynn.com/products/flow-ease-bra",
          image: Founder100Assets["FW-YG-BRA002"],
          imagePosition: "50% 50%",
          colours: [
            {
              name: "Black",
              value: "#242321",
              image: Founder100Assets["FW-YG-BRA002-BLACK"]
            },
            {
              name: "Warm Sand",
              value: "#c1ad94",
              image: Founder100Assets["FW-YG-BRA002-WARM-SAND"]
            },
            {
              name: "Soft Lila",
              value: "#b8a8c9",
              image: Founder100Assets["FW-YG-BRA002-SOFT-LILA"]
            },
            {
              name: "Butter Cream",
              value: "#eadba1",
              image: Founder100Assets["FW-YG-BRA002-BUTTER-CREAM"]
            },
            {
              name: "Coastal Blue",
              value: "#6d8194",
              image: Founder100Assets["FW-YG-BRA002-COASTAL-BLUE"]
            }
          ]
        },
        {
          sku: "FW-YG-BRA003",
          name: "Flow Drift Bra",
          series: "Flow",
          price: 38,
          note: "Not every sports bra should look like one.",
          fabric: "81% Polyamide / 19% Elastane",
          colourCount: 3,
          sizeRange: "S-L",
          url: "https://formwynn.com/products/flow-drift-bra",
          image: Founder100Assets["FW-YG-BRA003"],
          imagePosition: "50% 50%",
          colours: [
            {
              name: "Black",
              value: "#242321",
              image: Founder100Assets["FW-YG-BRA003-BLACK"]
            },
            {
              name: "White",
              value: "#f7f4ec",
              image: Founder100Assets["FW-YG-BRA003-WHITE"]
            },
            {
              name: "Deep Wine",
              value: "#5c1f2b",
              image: Founder100Assets["FW-YG-BRA003-DEEP-WINE"]
            }
          ]
        },
        {
          sku: "FW-HB-BRA001",
          name: "Hybrid Race Bra",
          series: "Hybrid",
          price: 38,
          note: "Hybrid support for training and race rhythm.",
          fabric: "75% Polyamide / 25% Elastane",
          colourCount: 3,
          sizeRange: "S-L",
          url: "https://formwynn.com/products/hybrid-race-bra",
          image: Founder100Assets["FW-HB-BRA001"],
          imagePosition: "50% 50%",
          colours: [
            {
              name: "Obsidian Black",
              value: "#242321",
              image: Founder100Assets["FW-HB-BRA001-OBSIDIAN-BLACK"]
            },
            {
              name: "Angola Red",
              value: "#7d2a2e",
              image: Founder100Assets["FW-HB-BRA001-ANGOLA-RED"]
            },
            {
              name: "Deep Navy",
              value: "#202a38",
              image: Founder100Assets["FW-HB-BRA001-DEEP-NAVY"]
            }
          ]
        }
      ]
    }
  }
};

const order = BUILDER_CONTENT.stepOrder;
const sizeOrder = BUILDER_CONTENT.sizeOrder;
const chart = BUILDER_CONTENT.sizeChart;
const products = Object.fromEntries(
  Object.entries(BUILDER_CONTENT.steps).map(([key, step]) => [
    key,
    {
      label: step.label,
      step: step.step,
      prompt: step.prompt,
      active: step.startsOpen,
      sizes: step.sizes,
      items: step.products.map((item) => ({
        sku: item.sku,
        name: item.name,
        price: item.price,
        note: item.note,
        series: item.series,
        fabric: item.fabric,
        colourCount: item.colourCount,
        sizeRange: item.sizeRange,
        unavailableOptions: item.unavailableOptions || [],
        colours: item.colours || [],
        url: item.url,
        image: item.image,
        imgPos: item.imagePosition || "50% 50%"
      }))
    }
  ])
);
const availableSizes = Object.fromEntries(
  Object.entries(BUILDER_CONTENT.steps).map(([key, step]) => [key, step.sizes])
);
const selected = {};
let mobileWizardStep = 0;

function getProductColour(product, colourName) {
  if (!product || !colourName || !Array.isArray(product.colours)) {
    return null;
  }

  return product.colours.find((colour) => colour.name === colourName) || null;
}

function getProductImage(product, colourName) {
  const selectedColour = getProductColour(product, colourName);
  const colourImage = selectedColour?.image;

  if (typeof colourImage === "string" && colourImage.trim() !== "") {
    return colourImage;
  }

  return product?.image || "";
}

function isMobileWizard() {
  return typeof window.matchMedia === "function" && window.matchMedia("(max-width: 749px)").matches;
}

function isComplete(key) {
  const current = selected[key];
  return Boolean(
    current
      && current.product
      && current.color
      && current.size
      && isOptionAvailable(current.product, current.color, current.size)
  );
}

function isOptionAvailable(product, color, size) {
  if (!product || !color || !size) return true;
  const productOptions = product.unavailableOptions || [];
  const sectionOptions = configuredSoldOutOptions().filter((option) => (
    normalizeOption(option.sku) === normalizeOption(product.sku)
  ));
  return ![...productOptions, ...sectionOptions].some((option) => (
    normalizeOption(option.color) === normalizeOption(color)
      && normalizeOption(option.size) === normalizeOption(size)
  ));
}

function mobileSelectionLine(key) {
  const current = selected[key];
  if (!isComplete(key)) return "Choose style, colour and size";
  return `${current.product.name} · ${current.color} · ${current.size}`;
}

function mobileWizardMarkup() {
  const activeKey = order[mobileWizardStep] || order[0];
  const activeGroup = products[activeKey];
  const progress = ((mobileWizardStep + 1) / order.length) * 100;
  const chips = order.map((key, index) => {
    const complete = isComplete(key);
    const isCurrent = index === mobileWizardStep;
    const disabled = complete || isCurrent ? "" : "disabled";
    const label = complete ? mobileSelectionLine(key) : products[key].label;
    return `
      <button
        class="mobile-wizard-chip ${complete ? "is-complete" : ""} ${isCurrent ? "is-current" : ""}"
        type="button"
        data-mobile-step="${index}"
        ${disabled}
      >${label}</button>
    `;
  }).join("");

  return `
    <div class="mobile-wizard" aria-label="Founder set mobile steps">
      <div class="mobile-wizard-topline">
        <span>Step ${mobileWizardStep + 1} of ${order.length}</span>
        <span>${activeGroup.label}</span>
      </div>
      <div class="mobile-wizard-progress" aria-hidden="true">
        <span style="width:${progress}%"></span>
      </div>
      <div class="mobile-wizard-chips" aria-label="Selected pieces">${chips}</div>
    </div>
  `;
}

function goToMobileWizardStep(index) {
  mobileWizardStep = Math.max(0, Math.min(order.length - 1, index));
  const key = order[mobileWizardStep];
  if (key) products[key].active = true;
  renderAll();
  document.getElementById("builder")?.scrollIntoView({ behavior: "smooth", block: "start" });
}

function goToNextMobileWizardStep() {
  const key = order[mobileWizardStep];
  if (!isComplete(key)) return;
  if (mobileWizardStep >= order.length - 1) {
    openReview();
    return;
  }
  goToMobileWizardStep(mobileWizardStep + 1);
}

function renderSteps() {
  const root = document.getElementById("builderSteps");
  const activeMobileKey = order[mobileWizardStep] || order[0];
  const stepsMarkup = order.map((key) => {
    const group = products[key];
    const current = selected[key];
    const complete = isComplete(key);
    const isMobileActive = key === activeMobileKey;
    let status = group.active ? "Select a style, colour and size." : "Choose after the previous step.";
    if (current && current.product && !current.color) status = `${current.product.name} · Select a colour.`;
    if (current && current.product && current.color && !current.size) status = `${current.product.name} · ${current.color} · Select a size.`;
    if (complete) status = `${current.product.name} · ${current.color} · ${current.size}`;
    const cards = group.items.map((item, index) => {
      const isSelectedProduct = current && current.product && current.product.sku === item.sku;
      const activeColour = isSelectedProduct ? current.color : null;
      const activeSize = isSelectedProduct ? current.size : null;
      const displayImage = getProductImage(item, activeColour);
      const cardColorButtons = item.colours.map((color) => `
        <span class="swatch-choice ${isSelectedProduct && activeColour === color.name ? "is-selected" : ""}">
          <button
            class="swatch-button product-card-swatch"
            type="button"
            data-key="${key}"
            data-product="${index}"
            data-colour-name="${color.name}"
            style="background:${color.value}"
            aria-label="${color.name}"
            aria-pressed="${isSelectedProduct && activeColour === color.name ? "true" : "false"}"
          ></button>
          <span class="swatch-caption">${isSelectedProduct && activeColour === color.name ? color.name : ""}</span>
        </span>
      `).join("");
      const cardSizeButtons = availableSizes[key].map((size) => {
        const disabled = activeColour && !isOptionAvailable(item, activeColour, size);
        return `
        <button
          class="size-button product-card-size"
          type="button"
          data-key="${key}"
          data-product="${index}"
          data-size="${size}"
          aria-pressed="${isSelectedProduct && activeSize === size ? "true" : "false"}"
          ${disabled ? 'disabled title="This size is sold out."' : ""}
        >${size}</button>
        `;
      }).join("");

      return `
        <article class="product-card ${isSelectedProduct ? "is-active" : ""}">
          <button class="product-select" type="button" data-key="${key}" data-product="${index}" aria-pressed="${isSelectedProduct ? "true" : "false"}">
            <span class="product-photo">
              <img src="${displayImage}" alt="${item.name}${activeColour ? ` - ${activeColour}` : ""}" style="object-position:${item.imgPos}">
              <span class="selected-tick">✓</span>
            </span>
            <span class="product-body">
              <span class="product-title-row"><span>${item.name}</span><span>${formatPrice(item.price, item.sku)}</span></span>
              <p class="product-sub">${item.note}</p>
            </span>
          </button>
          <a class="product-link" href="${item.url}" target="_blank" rel="noreferrer">View product</a>
          <div class="product-card-options">
            <div class="product-card-option-row">
              <div class="option-label">Colour</div>
              <div class="swatches">${cardColorButtons}</div>
            </div>
            <div class="product-card-option-row">
              <div class="option-label">Size</div>
              <div class="sizes">${cardSizeButtons}</div>
            </div>
          </div>
        </article>
      `;
    }).join("");

    return `
      <section class="step ${isMobileActive ? "is-mobile-active" : ""} ${current?.product ? "has-mobile-product" : ""}" data-step="${key}">
        <div class="step-head">
          <div class="step-number">${group.step}</div>
          <div>
            <h3>${group.prompt}</h3>
            <div class="step-status">${complete ? "✓ " : ""}${status}</div>
          </div>
          ${current ? `<button class="edit-link" type="button" data-edit="${key}">Edit</button>` : ""}
        </div>
        <div class="product-grid">${cards}</div>
        <div class="size-help step-size-help">
          <button class="size-help-toggle" type="button" data-help="${key}">Find my size</button>
          <div class="size-drawer" id="drawer-${key}">
            <p class="eyebrow">Size recommendation</p>
            <div class="measure-grid">
              <div class="measure-field"><label>Bust</label><input type="number" inputmode="decimal" data-measure="${key}-bust" placeholder="cm"></div>
              <div class="measure-field"><label>Waist</label><input type="number" inputmode="decimal" data-measure="${key}-waist" placeholder="cm"></div>
              <div class="measure-field"><label>Hip</label><input type="number" inputmode="decimal" data-measure="${key}-hip" placeholder="cm"></div>
            </div>
            <div class="fit-options" role="group" aria-label="Preferred fit">
              <button class="fit-button" type="button" data-fit="${key}" data-fit-value="supportive" aria-pressed="false">Supportive</button>
              <button class="fit-button" type="button" data-fit="${key}" data-fit-value="comfort" aria-pressed="true">Everyday comfort</button>
              <button class="fit-button" type="button" data-fit="${key}" data-fit-value="softer" aria-pressed="false">Softer fit</button>
            </div>
            <button class="fw-button secondary" type="button" style="margin-top:16px;" data-recommend="${key}">Recommend my size</button>
            <div class="recommend-result" id="result-${key}">
              <p class="helper-note">Recommended size</p>
              <p class="recommend-size" data-result-size="${key}">M</p>
              <p class="helper-note" data-result-copy="${key}">Based on your measurements, M should give you an everyday supportive fit.</p>
              <p class="helper-note">Between sizes? Choose the smaller size for stronger hold or the larger size for softer everyday wear.</p>
            </div>
          </div>
        </div>
      </section>
    `;
  }).join("");

  root.innerHTML = `${mobileWizardMarkup()}${stepsMarkup}`;
}

function completedCount() {
  return order.filter((key) => selected[key] && selected[key].product && selected[key].color && selected[key].size).length;
}

function hasRetailValues() {
  return order.every((key) => {
    const price = selected[key]?.product?.price;
    return Number.isFinite(Number(price));
  });
}

function formatPrice(price, fallback = "Pending") {
  return Number.isFinite(Number(price)) ? `£${Number(price)}` : fallback;
}

function retailTotal() {
  return order.reduce((sum, key) => {
    const current = selected[key];
    const price = current && current.product && current.color && current.size ? current.product.price : null;
    return Number.isFinite(Number(price)) ? sum + Number(price) : sum;
  }, 0);
}

function renderSummary() {
  const root = document.getElementById("summaryRows");
  root.innerHTML = order.map((key) => {
    const current = selected[key];
    return `
      <div class="summary-row">
        <div class="summary-dot">${current && current.size ? "✓" : "○"}</div>
        <div>
          <div class="summary-title">${products[key].label}</div>
          <div class="summary-meta">${current && current.size ? `${current.product.name}<br>${current.color} · ${current.size}` : "Choose"}</div>
        </div>
      </div>
    `;
  }).join("");

  const count = completedCount();
  const total = retailTotal();
  document.getElementById("progressFill").style.width = `${(count / 3) * 100}%`;
  document.getElementById("progressText").textContent = `${count} / 3 complete`;
  document.getElementById("retailValue").textContent = total ? `£${total}` : SECTION_COPY.pending;
  const activeMobileKey = order[mobileWizardStep] || order[0];
  const activeMobileComplete = isComplete(activeMobileKey);
  document.getElementById("mobileSummaryText").textContent = activeMobileComplete ? mobileSelectionLine(activeMobileKey) : "Choose style, colour and size";
  document.getElementById("reviewButton").disabled = count !== 3;
  const mobilePrimary = document.getElementById("mobileWizardPrimary");
  if (mobilePrimary) {
    mobilePrimary.disabled = !activeMobileComplete;
    mobilePrimary.textContent = mobileWizardStep === order.length - 1 ? "Review" : "Next";
  }
  document.getElementById("readyPanel").classList.toggle("active", count === 3);
}

function chooseProduct(key, index) {
  const current = selected[key] || {};
  const product = products[key].items[index];
  const keepsColour = product.colours.some((colour) => colour.name === current.color);
  const nextColor = keepsColour ? current.color : null;
  const nextSize = nextColor && isOptionAvailable(product, nextColor, current.size)
    ? current.size || null
    : null;
  selected[key] = {
    product,
    color: nextColor,
    size: nextSize
  };
  products[key].active = true;
  renderAll();
}

function chooseColor(key, color, index) {
  const product = Number.isFinite(index) ? products[key].items[index] : selected[key]?.product;
  if (!product) return;
  const keepsSize = selected[key]?.product?.sku === product.sku ? selected[key].size : null;
  selected[key] = {
    product,
    color,
    size: isOptionAvailable(product, color, keepsSize) ? keepsSize || null : null
  };
  products[key].active = true;
  renderAll();
}

function chooseSize(key, size, index) {
  const product = Number.isFinite(index) ? products[key].items[index] : selected[key]?.product;
  if (!product) return;
  const current = selected[key];
  const keepsColour = current?.product?.sku === product.sku && current.color;
  const fallbackColour = product.colours[0]?.name || "";
  const color = keepsColour || fallbackColour;
  if (!isOptionAvailable(product, color, size)) return;
  selected[key] = {
    product,
    color,
    size
  };
  selected[key].size = size;
  const currentIndex = order.indexOf(key);
  const next = order[currentIndex + 1];
  if (next) products[next].active = true;
  renderAll();
  if (isMobileWizard()) return;
  const nextStep = next ? document.querySelector(`[data-step="${next}"]`) : null;
  if (nextStep) nextStep.scrollIntoView({ behavior: "smooth", block: "start" });
}

function recommendSize(key) {
  const bust = Number(document.querySelector(`[data-measure="${key}-bust"]`)?.value);
  const waist = Number(document.querySelector(`[data-measure="${key}-waist"]`)?.value);
  const hip = Number(document.querySelector(`[data-measure="${key}-hip"]`)?.value);
  const fit = document.querySelector(`[data-fit="${key}"][aria-pressed="true"]`)?.dataset.fitValue || "comfort";
  const metric = key === "bra" ? bust : Math.max(waist || 0, hip ? hip - 24 : 0);
  let index = chart.findIndex((row) => row.size === "M");

  if (key === "bra" && bust) {
    index = nearestIndex("bust", bust);
  } else if (waist || hip) {
    const waistIndex = waist ? nearestIndex("waist", waist) : index;
    const hipIndex = hip ? nearestIndex("hip", hip) : index;
    index = Math.max(waistIndex, hipIndex);
    if (Math.abs(waistIndex - hipIndex) <= 1) {
      if (fit === "supportive") index = Math.min(waistIndex, hipIndex);
      if (fit === "softer") index = Math.max(waistIndex, hipIndex);
    }
  } else if (metric) {
    index = nearestIndex("waist", metric);
  }

  const size = chart[clampIndexToAvailable(index, key)].size;
  const tone = fit === "supportive" ? "a closer, more supportive fit" : fit === "softer" ? "a softer everyday fit" : "an everyday supportive fit";
  document.querySelector(`[data-result-size="${key}"]`).textContent = size;
  document.querySelector(`[data-result-copy="${key}"]`).textContent = `Based on your measurements, ${size} should give you ${tone}. This recommendation is guidance only. Please check the full Size Guide before ordering.`;
  document.getElementById(`result-${key}`).classList.add("active");
}

function nearestIndex(type, value) {
  let best = 0;
  let bestDistance = Infinity;
  chart.forEach((row, index) => {
    const mid = (row[type][0] + row[type][1]) / 2;
    const distance = Math.abs(mid - value);
    if (distance < bestDistance) {
      best = index;
      bestDistance = distance;
    }
  });
  return best;
}

function clampIndexToAvailable(index, key) {
  const boundedIndex = Math.max(0, Math.min(chart.length - 1, index));
  const allowed = availableSizes[key];
  if (allowed.includes(chart[boundedIndex].size)) return boundedIndex;

  let closestSize = allowed[0];
  let closestDistance = Infinity;
  allowed.forEach((size) => {
    const distance = Math.abs(sizeOrder.indexOf(size) - boundedIndex);
    if (distance < closestDistance) {
      closestSize = size;
      closestDistance = distance;
    }
  });
  return chart.findIndex((row) => row.size === closestSize);
}

function renderReview() {
  const list = document.getElementById("reviewList");
  list.innerHTML = order.map((key) => {
    const current = selected[key];
    const reviewImage = getProductImage(current.product, current.color);
    return `
      <div class="review-item">
        <div class="review-thumb"><img src="${reviewImage}" alt="${current.product.name} - ${current.color}" style="object-position:${current.product.imgPos}"></div>
        <div>
          <h3>${products[key].label}</h3>
          <p class="helper-note">${current.product.name}<br>${current.color} · ${current.size}</p>
        </div>
        <strong>${formatPrice(current.product.price, "Retail pending")}</strong>
      </div>
    `;
  }).join("");
  document.getElementById("modalRetail").textContent = retailTotal() ? `£${retailTotal()}` : SECTION_COPY.pending;
}


function selectionLine(key) {
  const current = selected[key];
  if (!current || !current.product || !current.color || !current.size) return "";
  return `${current.product.name} / ${current.color} / ${current.size}`;
}

function selectedProperties() {
  return {
    "Short": selectionLine("short"),
    "_Short SKU": selected.short?.product?.sku || "",
    "Legging": selectionLine("legging"),
    "_Legging SKU": selected.legging?.product?.sku || "",
    "Bra": selectionLine("bra"),
    "_Bra SKU": selected.bra?.product?.sku || "",
    "Retail value": `£${retailTotal()}`,
    "Founder price": "£39",
    "Included": "Founder-only Breath Anchor",
    "Founder 100": "Early-user release"
  };
}

function shopifyRoute(path) {
  const root = window.Shopify?.routes?.root || "/";
  const normalizedRoot = String(root || "/").endsWith("/") ? String(root || "/") : `${root}/`;
  return `${normalizedRoot}${String(path).replace(/^\//, "")}`;
}

async function checkoutFounderSet() {
  if (completedCount() !== 3) return;
  const status = document.getElementById("checkoutStatus");
  const founderVariantId = pageRoot?.dataset.founderVariantId;

  if (!founderVariantId) {
    if (status) status.textContent = "Founder 100 checkout product is not connected in the theme editor yet.";
    return;
  }

  if (status) status.textContent = "Preparing your Founder Set...";

  try {
    const response = await fetch(shopifyRoute("cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: Number(founderVariantId),
            quantity: 1,
            properties: selectedProperties()
          }
        ]
      })
    });

    if (!response.ok) throw new Error("cart_add_failed");
    window.location.assign(shopifyRoute("checkout"));
  } catch (error) {
    if (status) status.textContent = "We could not start checkout. Please try again or contact us.";
  }
}

function openReview() {
  if (completedCount() !== 3) return;
  renderReview();
  document.getElementById("reviewModal").classList.add("active");
}

function closeReview() {
  document.getElementById("reviewModal").classList.remove("active");
}

function renderAll() {
  renderSteps();
  renderSummary();
  bindEvents();
}

function bindEvents() {
  document.querySelectorAll("[data-product]").forEach((button) => {
    button.addEventListener("click", () => chooseProduct(button.dataset.key, Number(button.dataset.product)));
  });
  document.querySelectorAll("[data-colour-name]").forEach((button) => {
    button.addEventListener("click", () => chooseColor(button.dataset.key, button.dataset.colourName, Number(button.dataset.product)));
  });
  document.querySelectorAll("[data-size]").forEach((button) => {
    button.addEventListener("click", () => chooseSize(button.dataset.key, button.dataset.size, Number(button.dataset.product)));
  });
  document.querySelectorAll("[data-edit]").forEach((button) => {
    button.addEventListener("click", () => {
      products[button.dataset.edit].active = true;
      if (isMobileWizard()) {
        goToMobileWizardStep(order.indexOf(button.dataset.edit));
        return;
      }
      document.querySelector(`[data-step="${button.dataset.edit}"]`).scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });
  document.querySelectorAll("[data-mobile-step]").forEach((button) => {
    button.addEventListener("click", () => goToMobileWizardStep(Number(button.dataset.mobileStep)));
  });
  document.querySelectorAll("[data-help]").forEach((button) => {
    button.addEventListener("click", () => document.getElementById(`drawer-${button.dataset.help}`).classList.toggle("active"));
  });
  document.querySelectorAll("[data-fit]").forEach((button) => {
    button.addEventListener("click", () => {
      document.querySelectorAll(`[data-fit="${button.dataset.fit}"]`).forEach((peer) => peer.setAttribute("aria-pressed", "false"));
      button.setAttribute("aria-pressed", "true");
    });
  });
  document.querySelectorAll("[data-recommend]").forEach((button) => {
    button.addEventListener("click", () => recommendSize(button.dataset.recommend));
  });
  document.querySelectorAll(".faq-button").forEach((button) => {
    button.onclick = () => {
      const item = button.closest(".faq-item");
      const isOpen = item.classList.toggle("open");
      button.setAttribute("aria-expanded", String(isOpen));
      const marker = button.querySelector("span");
      if (marker) marker.textContent = isOpen ? "-" : "+";
    };
  });
}

function bindStaticEvents() {
  const staticHandlers = [
    ["reviewButton", openReview],
    ["mobileWizardPrimary", goToNextMobileWizardStep],
    ["readyReviewButton", openReview],
    ["closeModal", closeReview],
    ["editSelection", closeReview],
    ["checkoutButton", checkoutFounderSet]
  ];

  staticHandlers.forEach(([id, handler]) => {
    const element = document.getElementById(id);
    if (element) element.onclick = handler;
  });

  const modal = document.getElementById("reviewModal");
  if (modal) {
    modal.onclick = (event) => {
      if (event.target.id === "reviewModal") closeReview();
    };
  }
}

function initFounder100Builder() {
  refreshSectionContext();
  if (!pageRoot || !document.getElementById("builderSteps")) return;
  renderAll();
  bindStaticEvents();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFounder100Builder);
} else {
  initFounder100Builder();
}

document.addEventListener("shopify:section:load", initFounder100Builder);
})();
